<template>
  <div>
    <AddButton :content="$t('childServiceTable.button.add.title')" style="margin-bottom: 22px" @click="dialog.create = true" />
    <BaseTable :data="sortTableData">
      <EmptyBlock slot="empty" />
      <BaseElTableColumn :label="$t('childServiceTable.table.image.title')" prop="image" width="200">
        <template slot-scope="scope">
          <img style="margin: auto" width="90" :src="imgSource(scope.row.Image)" alt="">
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('childServiceTable.table.name.title')" prop="name" />
      <BaseElTableColumn prop="bookingTime" :label="$t('childServiceTable.table.bookingTime.title')" width="150" align="center" />
      <BaseElTableColumn prop="showTime" :label="$t('childServiceTable.table.showTime.title')" width="150" align="center">
        <template slot-scope="scope">
          {{ !scope.row.showTime || scope.row.showTime === 0 ? '-' : scope.row.showTime }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="price" :label="$t('childServiceTable.table.price.title')" width="120" align="center" />
      <BaseElTableColumn v-if="(chargeType === 'checkout' && useFeatures.forceCanHidePrice) || chargeType !== 'checkout'" prop="showPrice" :label="$t('childServiceTable.table.showPrice.title')" width="120" align="center">
        <template slot-scope="scope">
          {{ !scope.row.showPrice || scope.row.showPrice === '0' ? '-' : scope.row.showPrice }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn :label="$t('childServiceTable.table.order.title')" prop="order" />
      <BaseElTableColumn prop="name" :label="$t('common.table.action.text')" fixed="right" width="110" align="center">
        <template slot-scope="scope">
          <TableEditBtnGroup
            @edit=";(dialog.edit = true), (selectRow = scope.row)"
            @delete=";(dialog.delete = true), (selectRow = scope.row)"
          />
        </template>
      </BaseElTableColumn>
    </BaseTable>

    <DeleteDialog
      v-if="dialog.delete"
      :title="$t('common.dialog.delete.title')"
      :content="$t('common.dialog.delete.content')"
      width="40%"
      @close="dialog.delete = false"
      @delete="deleteSubService"
    />

    <CreateChildServiceDialog
      v-if="dialog.create"
      type="create"
      :mainService="mainService"
      :configData="configData"
      @created="onSubServiceCreate"
      @close="dialog.create = false"
    />
    <CreateChildServiceDialog
      v-if="dialog.edit"
      type="edit"
      :service="selectRow"
      :mainService="mainService"
      :configData="configData"
      @edited="onSubServiceEdit"
      @close="dialog.edit = false"
    />
  </div>
</template>

<script>
import tableMixin from '@/mixin/table'
import EmptyBlock from '@/components/EmptyBlock.vue'
import CreateChildServiceDialog from './CreateChildServiceDialog.vue'
import { GetSubService } from '@/api/service'
import { findIndex, map, get } from 'lodash'
import { imgSrc } from '@/utils/helper'
import { computed } from 'vue'
import { usePermissions } from '@/use/permissions'
import { i18n } from '@/plugins/i18n/i18n'

export default {
  name: 'ChildServiceTable',
  components: { EmptyBlock, CreateChildServiceDialog },
  mixins: [tableMixin],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    mainService: {
      type: Object,
      default: () => ({}),
    },
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    const { checkAction } = usePermissions()
    const chargeType = computed(() => {
      return get(props.configData, 'reservation.chargeType')
    })
    const useFeatures = computed(() => {
      return {
        forceCanHidePrice: checkAction('admin.appointmentSubService.enableShowPrice'),
      }
    })

    return {
      chargeType,
      useFeatures,
    }
  },
  data: () => ({
    tableData: [],
    imgSize: 300,
  }),
  computed: {
    compactData () {
      const dataList = []
      this.tableData.forEach((item) => {
        if (!item.hidePrice) item.showPrice = '0'
        if (!item.hideTime) item.showTime = '0'
        const data = {
          name: item.name,
          image: get(item, 'Image.id'),
          description: item.description || undefined,
          price: item.price,
          showPrice: item.showPrice === '' ? '0' : item.showPrice,
          showTime: item.showTime === '' ? 0 : item.showTime,
          bookingTime: item.bookingTime,
          order: item.order,
          allAppointmentUnit: !item.serviceUnits.length,
          allResourceItem: item.resourceItems ? !item.resourceItems.length : false,
          appointmentUnits: map(item.serviceUnits, 'id'),
          resourceItems: map(item.resourceItems, 'id'),
        }
        if (item.id) data.id = item.id
        dataList.push(data)
      })
      return dataList
    },
    sortTableData () {
      let services = this.tableData
      if (!services) return []
      services = services.sort((a, b) => a.order - b.order)
      return services
    },
  },
  watch: {
    compactData () {
      this.$emit('update', this.compactData)
    },
  },
  mounted () {
    this.data.forEach((i) => this.syncData(i))
  },
  methods: {
    async refresh () {
      this.loading = true
      await this.getService()
      this.loading = false
    },

    imgSource (image) {
      return imgSrc(this.imgSize, image)
    },

    async getService () {
      console.log('here')
      const [res, err] = await GetSubService({
        shopId: this.shop,
        start: this.pageStartIndex,
        limit: this.tableOptions.pageLimit,
        name: this.nameSearch || undefined,
      })
      console.log('here', res)
      if (err) {
        this.$message.error(err)
        return
      }
      if (res) this.tableData = res
    },

    async deleteSubService () {
      this.tableData = this.tableData.filter((i) => i.id !== this.selectRow.id)
      // await this.refresh()
      this.$message.success(i18n.t('childServiceTable.message.deleteSubService.text'))
      this.dialog.delete = false
    },

    onSubServiceCreate (data) {
      this.tableData.push(data)
    },
    onSubServiceEdit (data) {
      const targetIndex = findIndex(this.tableData, this.selectRow)
      if (targetIndex !== -1) {
        this.$set(this.tableData, targetIndex, data)
        // this.tableData[targetIndex] = data
      }
    },
    syncData (res) {
      const data = {
        avatar: res.avatar,
        name: res.name,
        description: res.description,
        isPublic: res.isPublic,
        order: res.order,
        price: res.price,
        Image: res.Image,
        bookingTime: res.bookingTime,
        serviceUnits: res.AppointmentUnits,
        resourceItems: res.ResourceItems,
        id: res.id,
      }
      if (res.showPrice !== '0') {
        data.hidePrice = true
        data.showPrice = res.showPrice
      }
      if (res.showTime !== '0') {
        data.hideTime = true
        data.showTime = res.showTime
      }
      this.tableData.push(data)
    },
  },
}
</script>
